import { useEffect } from 'react';
import { ErrorProps, Error as RaError } from 'react-admin';

import { reportCrash } from '@Utils/analytics';

/**
 * react-admin's error page, with the crash reported on the way through.
 *
 * Wired via `<Layout error={AnalyticsErrorPage} />`, which is where react-admin's own error
 * boundary renders — the only place a render crash inside a page is observable.
 *
 * @param props Error and component stack from react-admin's boundary
 */
export const AnalyticsErrorPage = (props: ErrorProps) => {
  const { error, errorInfo } = props;

  useEffect(() => {
    reportCrash(error, errorInfo?.componentStack ?? '');
  }, [error, errorInfo]);

  return <RaError {...props} resetErrorBoundary={() => window.location.reload()} />;
};
